<script>
  import config from '../../libs/config.json';
  import func from '../../libs/functions.js';

  import _system from '../../libs/system';
	import { mapGetters, mapActions } from 'vuex'
  
  import api from '../../api/public'
  import apiPrivate from '../../api'

  import validate from 'validate.js'

  import AOS from 'aos'
  import 'aos/dist/aos.css'

     import { db } from '../../firebase';
import rootVue from '../dashboard/bits/facebook/root.vue';

	export default 
	{
    name: 'signup',
    data(){
      return {
        func: func,
        config: config,
        loading: false,
        mobile: false,
        change: false,
        show: false,
        whiteLabelLogo: '',
        pkey: '',
        aid: '',
        shield: false,
        shopifyUrl:'',
        growsumo: {},
        signUp: {
          name: '',
          email: '',
          password: '',
          password2: '',
          token: ''
        },
        error: {
          password: false,
          email: {
            invalid: false,
            exist: false,
          },
          name: false
        }
      }
    },
    computed:{
      ...mapGetters('session', ['isLoggedIn', 'getJwt', 'getUser']),
      ...mapGetters('tags', ['tags', 'tagsByName'])
    },
      methods: 
      {
        ...mapActions('session', ['login','setIsLoggedIn']),
        ...mapActions('tags', ['setTags']),
        signUpWithGmail(){
         if(window.analytics && window.analytics.user && window.analytics.user() && window.analytics.user().anonymousId()){
            this.aid = window.analytics.user().anonymousId();
          }
          if(window.growsumo && window.growsumo.data && window.growsumo.data.partner_key){
             this.pkey = window.growsumo.data.partner_key;
          }

          JSON.stringify({'anonymousId': aid, 'partner_key': pkey })

          this.pkey = "jiro"
          this.aid = "sero"

          //document.getElementById('loginWithGmail').submit();

        }, 
        signUpFunc(){

          if(validate.single(this.signUp.email, {presence: true, email: true})){
            console.log(validate.single(this.signUp.email, {presence: true, email: true}))
            return alert(validate.single(this.signUp.email, {presence: true, email: true})[0])
          }

          if(validate.single(this.signUp.password, { presence: true, length: {minimum: 6,message: "must be at least 6 characters" }})){
            console.log(validate.single(this.signUp.password, { presence: true, length: {minimum: 6,message: "Password must be at least 6 characters" }}))
            return alert(validate.single(this.signUp.password, { presence: true, length: {minimum: 6,message: "Password must be at least 6 characters" }})[0])
          }

          if(this.signUp.password != this.signUp.password2){
            return this.error.password = true;
          }

          if(!this.signUp.name.length || !this.signUp.email.length || !this.signUp.password.length || !this.signUp.password2.length){
            return alert('Inputs cannot be empty')
          }

          this.loading = true;

          let payload = { "email": this.signUp.email.toLowerCase().trim(), "password": this.signUp.password.trim(), "name": this.signUp.name }

          payload["token"] = this.signUp.token;
          
          let url = '/api/v1/users'

          if(window.analytics && window.analytics.user && window.analytics.user() && window.analytics.user().anonymousId()){
            url = '/api/v1/users?anonymousId=' + window.analytics.user().anonymousId();
          }


          if(window.growsumo && window.growsumo.data && window.growsumo.data.partner_key){
            if(url.includes('?')){
               url = url + '&partner_key=' + window.growsumo.data.partner_key;
            }else{
               url = url + '?partner_key=' + window.growsumo.data.partner_key;
            }
          }
          
          //https://juphy-api.ngrok.io

          if(this.$route.query.ngrok && this.$route.query.ngrok.length){
            url = "https://juphy-api.ngrok.io" + url;
            console.log('ngrok.com active');
          }else{
            url = "https://api.juphy.com" + url;
            console.log('api.juphy.com active');
          }

          // User Sign Up
          api.postNgrok(url, payload, (err, data) => {

              if(err) {
                this.loading = false
                if(err.status == 409) return this.error.email.exist = true;
                if(err.status == 422) return this.error.email.invalid = true;
            }
              data.user.setup = true

              this.login({
                jwt: data.accessToken,
                user: data.user
              });
              this.setIsLoggedIn();

          //Create a workspace for new user
          _system.services.tags.getWithoutWorkspaceId((err, tags) => {
            this.setTags(tags); 
              let payload = { "name": this.getUser.name+"'s Workspace", tags: [this.tagsByName['Individual']._id] }
              _system.services.workspaces.create(payload, (err, workspace) => {
                if (err) return console.log(err);
                  let payload = {
                    workspace: workspace._id,
                    user:  this.getUser._id,
                    tags :  [this.tagsByName['Admin']._id]
                  }
                  _system.services.workspaceusers.add(payload, (err, data) => {
                    if (err) return console.log(err);
                      this.loading = false;


                        let payload = {
                           query: {
                              userId: this.getUser._id
                           },
                           body:{
                              workspace: workspace._id
                           }
                        };
                        _system.services.user.updatePreferencesForWorkspace(payload, (err, result) => {
                           if(err) console.log(err)
                        });

                      //segmenti
                      //window.analytics.alias({ previousId: window.analytics.user().anonymousId(), userId: this.getUser._id });

/*                       window.analytics.identify(this.getUser._id, {
                        id: this.getUser._id,
                        name: this.getUser.name,
                        email: this.getUser.email
                      }); */
                      

                      this.$router.push({ name: "inbox" });

                      window.fbq('track', 'CompleteRegistration');

                      window.qp('track', 'CompleteRegistration');

                      window.ga('send', 'event', 'Func', 'Auth', 'Signed Up', 1);

                      window.gtag('event', 'conversion', {'send_to': 'AW-10862805758/cr9RCMj866gDEP6F5bso'});

                  });
              })
            })
          });
		    }
    }, 
    mounted(){
        let domain = window.location.hostname.toString();

        if(domain == 'app.juphy.com' || domain == 'localhost'  ){

          this.show = true
        }else{
          
        db.collection('domains')
        .doc(domain.replaceAll('.',''))
        .get()
        .then(snapshot => {
          const document = snapshot.data()
          this.whiteLabelLogo = document.url
        }).catch(()=>{
          console.log('Error reading one document.')
        })
        }

      if(window.growsumo && window.growsumo.data && window.growsumo.data.partner_key){
         window.growsumo.data.name = this.getUser.name;
         window.growsumo.data.email = this.getUser.email;
         window.growsumo.data.customer_key = this.getUser._id;
         this.growsumo = window.growsumo.data
      }

console.log('mounted')

      this.shield = true;
         window.turnstile.render('#shield', {
            theme: 'light',
            sitekey: '0x4AAAAAAACIk4q_P4CUArT0',
            callback: (token) => {
               this.shield = false;
               this.signUp.token = token;
                  //console.log(`Challenge Success ${token}`);
            },
         });

/* if (window.turnstile === null || !window.turnstile) {
        const script = document.createElement('script')
        script.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js'
        document.head.appendChild(script)
      }
      
      window.onloadTurnstileCallback =  () => {
         this.shield = true;
         window.turnstile.render('#shield', {
            theme: 'light',
            sitekey: '0x4AAAAAAACIk4q_P4CUArT0',
            callback: (token) => {
               this.shield = false;
               this.signUp.token = token;
                  console.log(`Challenge Success ${token}`);
            },
         });
      }; */





/* document.addEventListener("DOMContentLoaded", function(event) {
   var aid = "";
   var pkey = ""

      if(window.analytics && window.analytics.user && window.analytics.user() && window.analytics.user().anonymousId()){
         aid = window.analytics.user().anonymousId();
      }
      if(window.growsumo && window.growsumo.data && window.growsumo.data.partner_key){
         pkey = window.growsumo.data.partner_key;
      }
});
 */

/* setTimeout(() => {
   console.log(window.analytics.user().anonymousId())
      document.getElementById('state').value = JSON.stringify({'anonymousId': window.analytics.user().anonymousId(), 'partner_key': window.growsumo.data.partner_key });
}, 1500); */
      


          

            //document.getElementById('state')
          //JSON.stringify({'anonymousId': this.aid, 'partner_key': this.pkey })

    },
    created(){
      if(this.$route.query.email) {
        console.log(this.$route.query.email)
        this.change = false;
      }
      AOS.init();
                 if( navigator.userAgent.match(/Android/i) || navigator.userAgent.match(/webOS/i) || navigator.userAgent.match(/iPhone/i) || navigator.userAgent.match(/iPad/i) || navigator.userAgent.match(/iPod/i) || navigator.userAgent.match(/BlackBerry/i) || navigator.userAgent.match(/Windows Phone/i) ) this.mobile = true;
    }
	}
</script>

<template>
<keep-alive>
		<div :class="(mobile) ? 'ui grid stackable' : 'ui grid stackable' ">
		<div class="eight wide column">
		<div :class="(mobile) ? 'ui grid stackable padded' : 'ui grid stackable padded' ">
            <div class="sixteen wide column centered">

              <div data-aos="zoom-in" v-show="show" style="margin-top:5rem;" class="ui basic segment">
                <img class="ui image centered" style="width: 170px;" src="/img/logo_white7.png" alt="">
              </div>

          <div v-if="!show && whiteLabelLogo.length" style="margin-top:8rem;" data-aos="zoom-in" class="ui basic segment">
            <img class="ui image centered" style="width: 170px;" :src="whiteLabelLogo" alt="">
          </div>
    
                      <div class="ui basic segment">

                      <div  v-if="change" style="padding:0;" class="ui basic segment">


                          <a :href="config.url + '/facebook/auth'" style="text-align: left;font-weight: 400; margin-bottom: 10px;" class="ui facebook large button fluid">
                          <i class="facebook icon"></i>
                          Sign Up with Facebook <span style="color: #97b6e4; margin-left: 4px;font-style: italic; font-size: 12px; font-weight: 400;">  Page's Comments, Direct Messages</span>
                          </a>
                        

                        <p @click="change = false" style="text-align: center;"> <span class="goEmail">Or continue with email  </span> </p>

                      </div>
<!-- 
<div style="
  background: #f1f8f5;
  border-radius: 0.5rem;" class="ui basic segment">

<div class="ui fluid large form" style="margin-bottom: 1rem;">
   <div class="fields">
    <div class="six wide field">
      <label>Store Name</label>
      <input type="text" v-model="shopifyUrl" placeholder="coolshirts">
    </div>
    <div class="ten wide field">
      <label>URL Preview</label>
      <span style="
display: inline-block;
  padding: 0.6rem 1rem;
  background: #e3f9ed;
  border-radius: 0.5rem;
  width: 100%;
  color: #52886a;
      ">https://{{(shopifyUrl.length) ? shopifyUrl : '_ _ _ _ _ _' }}.myshopify.com</span>
    </div>
   </div>
</div>

<form id="auth" class="ui large form" :action="'https://'+ shopifyUrl +'.myshopify.com/admin/oauth/authorize'" method="get">

<input type="text" name="state" :value="JSON.stringify({ 'userId': '' , 'workspaceId': '' })" hidden>

<input type="text" name="client_id" :value="'2316679a1744bbd29e22e8b6134920e6'" hidden>

<input type="text" name="redirect_uri" :value="config.url + '/shopify/redirect'" hidden>

<input type="text" name="grant_options[]" value="per-user" hidden>

<input type="text" name="prompt" :value="'consent'" hidden>

<input type="text" name="scope" :value="'read_products,read_products,read_product_listings'" hidden>

<button type="submit" value="Submit" class="ui teal large fluid button">Signup with Shopify Account </button>
</form>

</div>

<div class="ui horizontal divider">
    Or
  </div> -->

<!--                       <form action="https://quick-start-965b73bb.myshopify.com/admin/oauth/authorize" method="get" target="_blank">
                        <input type="text" name="state" value="{&quot;userId&quot;:&quot;5c6d250b9d65e69f3e46112b&quot;,&quot;workspaceId&quot;:&quot;5c6d250c5b26e05219f9e108&quot;}">

                        <input type="text" name="client_id" value="2316679a1744bbd29e22e8b6134920e6">
                        <input type="text" name="redirect_uri" value="https://api.juphy.com/shopify/redirect">
                        <input type="text" name="scope" value="write_products,read_products,write_product_listings,read_product_listings,write_product_feeds,read_product_feeds">
                        <input type="text" name="grant_options[]" value="per-user">
                        <input type="submit" id="shopify" value="Submit">

                     </form> -->


                        <div v-if="!change" style="padding: 1rem;
  background: #f6f6f6;
  border-radius: 0.5rem;" class="ui large form">
<!--                           <div v-if="mobile" class="field">
                            <div class="ui visible success message">
                              <p>🤩📱 Good News for yaa! Our mobile apps will be available soon for IOS and Android. </p>
                            </div>
                          </div> -->
                          <div class="field">
                              <label>Name</label>
                              <input v-model="signUp.name" placeholder="John Doe" type="text" :disabled="loading">
                          </div>
                          <div class="field">
                              <label>Business Email Address</label>
                              <input v-model="signUp.email" @input="signUp.email=$event.target.value.toLowerCase().trim()" placeholder="name@yourcompany.com" type="text" :disabled="loading">
                          </div>
                          <div v-show="error.email.exist" class="ui negative mini message ">
                            <p>This email is already in use. <a href="#">Forgot your password?</a> </p>
                          </div>
                          <div class="field">
                              <label>Password</label>
                              <input v-model="signUp.password" @input="signUp.password=$event.target.value.trim()" placeholder="Password" type="password" autocomplete="off" :disabled="loading">
                          </div>
                          <div v-if="signUp.password.length" class="field">
                              <label>Re-Type Your Password</label>
                              <input v-model="signUp.password2" @input="signUp.password2=$event.target.value.trim()" placeholder="Re-Type Your Password" type="password" autocomplete="off" v-on:keyup.enter="signUpFunc()" :disabled="loading">
                          </div>
                          <div v-show="error.password" class="ui negative mini message ">
                            <p>Passwords are not equal!</p>
                          </div>
                          <div style="text-align: center;" id="shield" class="field"></div>
                          <div class="field">
                            <button @click="signUpFunc()" v-bind:class="{ loading: loading }" :disabled="(loading || shield) ? true : false" class="ui orange large button fluid">Create My Account</button>
                          </div>

<!--             <div v-if="show" class="ui horizontal divider">OR</div>
              <form v-if="show" action="https://accounts.google.com/o/oauth2/auth" method="get" target="_blank">
                  <input type="text" name="client_id" value="958501235262-dhr2s7rhl7m2s0iteec832vfr3r76ni1.apps.googleusercontent.com" hidden>
                  <input type="text" name="redirect_uri" value="https://api.juphy.com/gmail/authentication" hidden>
                  <input type="text" name="response_type" value="code" hidden >
                  <input type="text" name="access_type" value="offline" hidden>
                  <input type="text" name="scope" value="https://www.googleapis.com/auth/userinfo.profile https://www.googleapis.com/auth/userinfo.email" hidden>
                  
                  <input id="state" type="text" name="state" hidden>

                  <button type="submit" value="Submit" class="ui google large button fluid"><i class="icon google"></i> Continue with Gmail </button>
              </form> -->

              <div v-show="show" style="color: #999; margin-top: 1rem;" class="ui basic segment footer">
            <p>By clicking 'Create My Account', I agree to Juphy's , <a href="https://juphy.com/terms">Terms of Service</a> & <a href="https://juphy.com/legal/acceptable-use-policy">Acceptable Use Policy</a> and acknowledge its <a href="https://juphy.com/privacy">Privacy Policy</a></p>
            </div>

                        </div>    
<!--                                                       <div class="ui warning message">
                                <div class="header">
                                  Periodic maintenance.
                                </div>
                                The system will be available at 2:00 PM PST
                              </div> -->
                      </div>                      
                </div>
            <div style="color: #999; position: absolute; top:0; left:0; right:50px;" class="ui basic segment right aligned footer">
            <p>Already have an account?  <router-link  to="/signin"><a href="">Sign In</a></router-link></p>
            </div>
</div>
</div>
<div style="background: #f5f5f5; height: 100%;" class="eight wide column">
  <div class="ui equal width grid">
    <div class="column">
                  <!-- Review 4 -->
            <div style="padding: 1rem; border-radius: 0.5rem; background: white; margin-bottom: 1rem;" class="shadow-sm">
               <div style="margin-bottom: 1rem;" class="ReviewOwner d-flex">
                  <div style="padding-right:1rem;" class="left pr-2">
                        <img 
                        class="ReviewOwnerImage rounded-circle"
                        width="100"
                        height="50"
                        style="width: 50px; border-radius: 50px;"
                        src="https://images.g2crowd.com/uploads/avatar/image/325128/thumb_square_58838f9b7a876b1c8a7fcafa499fa099.jpeg" 
                        />
                  </div>
                  <div class="right">
                        <div class="name">
                           <strong>
                              Fabrizio
                           </strong>
                        </div>
                        <div 
                        style="font-size: 14px;"
                        class="title">
                           Founder of digitalfastmind.com
                        </div>
                  </div>
               </div>
               <div style="font-size: 18px; margin-bottom: 1.5rem; line-height:1.5" class="ReviewText mb-4">
                  “Saving time by unifing all the reviews and comments from different platforms in one place.”
               </div>
               <div class="reviewBottom">
                  <div style="margin-bottom: 0.35rem;" class="G2ReviewVerifiedText">
                        <span style="font-size: 12px">
                           ✓ G2 Verified Review
                        </span>
                  </div>
                  <div class="G2ReviewImage">
                        <img 
                        width="100"
                        height="45"
                        style="width: 100px; height: auto;"
                        src="https://juphy.com/wp-content/uploads/2022/02/g2-5-stars.png" 
                        />
                  </div>
               </div>
            </div>
            <!-- Review 4 END -->
                        <!-- Review 1 -->
            <div style="padding: 1rem; border-radius: 0.5rem; background: white; margin-bottom: 1rem;" class="shadow-sm">
               <div style="margin-bottom: 1rem;" class="ReviewOwner d-flex">
                  <div style="padding-right:1rem;" class="left pr-2">
                        <img 
                        class="ReviewOwnerImage rounded-circle"
                        width="100"
                        height="50"
                        style="width: 50px; border-radius: 50px;"
                        src="https://juphy.com/wp-content/uploads/2021/11/1550159247351.jpg" 
                        />
                  </div>
                  <div class="right">
                        <div style="font-size: 16px;" class="name">
                           <strong>
                              Ankit Singla
                           </strong>
                        </div>
                        <div 
                        style="font-size: 14px;"
                        class="title">
                           Founder of MasterBlogging
                        </div>
                  </div>
               </div>
               <div style="font-size: 18px; margin-bottom: 1.5rem; line-height:1.5" class="ReviewText mb-4">
                  “It's such a time saver. I can easily manage all my social profiles in one place and I never miss a single message!”
               </div>
               <div class="reviewBottom">
                  <div style="margin-bottom: 0.35rem;" class="G2ReviewVerifiedText">
                        <span style="font-size: 12px">
                           ✓ G2 Verified Review
                        </span>
                  </div>
                  <div class="G2ReviewImage">
                        <img 
                        width="100"
                        height="45"
                        style="width: 100px; height: auto;"
                        src="https://juphy.com/wp-content/uploads/2022/02/g2-5-stars.png" 
                        />
                  </div>
               </div>
            </div>
            <!-- Review 1 END -->
                                    <!-- Review 6 -->
            <div style="padding: 1rem; border-radius: 0.5rem; background: white; margin-bottom: 1rem;" class="shadow-sm">
               <div style="margin-bottom: 1rem;" class="ReviewOwner d-flex">
                  <div class="right">
                        <div style="font-size: 16px;" class="name">
                           <strong>
                              Justin S.
                           </strong>
                        </div>
                        <div 
                        style="font-size: 14px;"
                        class="title">
                           Founder
                        </div>
                  </div>
               </div>
               <div style="font-size: 18px; margin-bottom: 1.5rem; line-height:1.5" class="ReviewText mb-4">
                  “The user interface is really clean and intuitive. It supports all of the important social platforms. The ticketing system is really well organized and it is easy to assign tasks, emails, and tickets.”
               </div>
               <div class="reviewBottom">
                  <div style="margin-bottom: 0.35rem;" class="G2ReviewVerifiedText">
                        <span style="font-size: 12px">
                           ✓ G2 Verified Review
                        </span>
                  </div>
                  <div class="G2ReviewImage">
                        <img 
                        width="100"
                        height="45"
                        style="width: 100px; height: auto;"
                        src="https://juphy.com/wp-content/uploads/2022/02/g2-5-stars.png" 
                        />
                  </div>
               </div>
            </div>
            <!-- Review 6 END -->
    </div>
    <div class="column">
                  <!-- Review 2 -->
            <div style="padding: 1rem; border-radius: 0.5rem; background: white; margin-bottom: 1rem;" class="shadow-sm">
               <div style="margin-bottom: 1rem;" class="ReviewOwner d-flex">
                  <div style="padding-right:1rem;" class="left pr-2">
                        <img 
                        class="ReviewOwnerImage rounded-circle"
                        width="100"
                        height="50"
                        style="width: 50px; border-radius: 50px;"
                        src="https://juphy.com/wp-content/uploads/2021/10/avatar-1.jpg" 
                        />
                  </div>
                  <div class="right">
                        <div class="name">
                           <strong>                       
                              A. Mariantisna 
                           </strong>
                        </div>
                        <div 
                        style="font-size: 14px;"
                        class="title">
                           Marketing Manager
                        </div>
                  </div>
               </div>
               <div style="font-size: 18px; margin-bottom: 1.5rem; line-height:1.5" class="ReviewText mb-4">
                  “Juphy definitely improved my team's productivity, while being able to interact with our audience as fast as possible!”
               </div>
               <div class="reviewBottom">
                  <div style="margin-bottom: 0.35rem;" class="G2ReviewVerifiedText">
                        <span style="font-size: 12px">
                           ✓ G2 Verified Review
                        </span>
                  </div>
                  <div class="G2ReviewImage">
                        <img 
                        width="100"
                        height="45"
                        style="width: 100px; height: auto;"
                        src="https://juphy.com/wp-content/uploads/2022/02/g2-5-stars.png" 
                        />
                  </div>
               </div>
            </div>
            <!-- Review 2 END -->

                        <!-- Review 3 -->
            <div style="padding: 1rem; border-radius: 0.5rem; background: white; margin-bottom: 1rem;" class="shadow-sm">
               <div style="margin-bottom: 1rem;" class="ReviewOwner d-flex">
                  <div style="padding-right:1rem;" class="left pr-2">
                        <img 
                        class="ReviewOwnerImage rounded-circle"
                        width="100"
                        height="50"
                        style="width: 50px; border-radius: 50px;"
                        src="https://images.g2crowd.com/uploads/avatar/image/384261/thumb_square_22b2a09fdf3e20d40706bf7a0ebb18ca.jpeg" 
                        />
                  </div>
                  <div class="right">
                        <div class="name">
                           <strong>
                              Rafael
                           </strong>
                        </div>
                        <div 
                        style="font-size: 14px;"
                        class="title">
                           Marketing Director
                        </div>
                  </div>
               </div>
               <div style="font-size: 18px; margin-bottom: 1.5rem; line-height:1.5" class="ReviewText mb-4">
                  “I love that I can view and manage all comments and messages from all of my social channels including app stores.”
               </div>
               <div class="reviewBottom">
                  <div style="margin-bottom: 0.35rem;" class="G2ReviewVerifiedText">
                        <span style="font-size: 12px">
                           ✓ G2 Verified Review
                        </span>
                  </div>
                  <div class="G2ReviewImage">
                        <img 
                        width="100"
                        height="45"
                        style="width: 100px; height: auto;"
                        src="https://juphy.com/wp-content/uploads/2022/02/g2-5-stars.png" 
                        />
                  </div>
               </div>
            </div>
            <!-- Review 3 END -->
                        <!-- Review 7 -->
            <div style="padding: 1rem; border-radius: 0.5rem; background: white;" class="shadow-sm">
               <div style="margin-bottom: 1rem;" class="ReviewOwner d-flex">
                  <div class="right">
                        <div class="name">
                           <strong>
                              David
                           </strong>
                        </div>
                        <div 
                        style="font-size: 14px;"
                        class="title">
                           Podcast Marketing Expert 
                        </div>
                  </div>
               </div>
               <div style="font-size: 18px; margin-bottom: 1.5rem; line-height:1.5" class="ReviewText mb-4">
                  “Juphy makes this easy by having all my accounts in a single place, so I can go in and handle all my messages very quickly. it had totally changed the way I do social media and given me back a lot of time.”
               </div>
               <div class="reviewBottom">
                  <div style="margin-bottom: 0.35rem;" class="G2ReviewVerifiedText">
                        <span style="font-size: 12px">
                           ✓ G2 Verified Review
                        </span>
                  </div>
                  <div class="G2ReviewImage">
                        <img 
                        width="100"
                        height="45"
                        style="width: 100px; height: auto;"
                        src="https://juphy.com/wp-content/uploads/2022/02/g2-5-stars.png" 
                        />
                  </div>
               </div>
            </div>
            <!-- Review 7 END -->
    </div>
  </div>
</div>
</div>
</keep-alive>
</template>


<style scoped>
.footer a {
  color: #999;
  border-bottom: 1px dotted #888888;
}

.goEmail {
  border-bottom: 1px solid #dddddd;
  color: #999999;
}

.goEmail:hover {
  border-bottom: 1px solid #aaaaaa;
  cursor:pointer;
}

.d-flex{
  display: flex;
}

</style>



// WEBPACK FOOTER //
// src/components/auth/Signup.vue